<template>
    <td-dialog
        :title="$t(title)"
        append-to-body="true"
        :before-close="menuDistributDialogClose"
        :visible.sync="dialogMenuDistributVisible"
        width="800px"
        height="520px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form>
            <td-table height="460px" :columns="nodecolumns" :hasPage="false" rowKey="menuId" :hasMutiSelect="true" :dataSource="menutableData" :hasLoading="nodeloading" ref="menutable"> </td-table>
        </el-form>
        <span slot="footer" style="text-align:left">
            <td-button @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'dialogMenuDistributVisible', 'templateKey', 'menuParam'],
    // 定义变量
    data() {
        return {
            nodeloading: false,
            menutableData: [],
            nodecolumns: [
                //表头
                {
                    prop: 'menuId',
                    label: 'pgCommon.ID',
                    align: 'center',
                    tableWidth: '163'
                },
                {
                    prop: 'menuName',
                    label: 'pgCommon.DEFAULT_CAPTION',
                    align: 'center',
                    tableWidth: '250'
                },
                {
                    prop: 'selfName',
                    label: 'pgCommon.SELF_CAPTION',
                    align: 'center',
                    tableWidth: '250',
                    render: (createElement, params) => {
                        console.info(params.row.selfName);
                        return createElement(
                            'td-input',
                            {
                                style: {
                                    marginTop: '3px',
                                    marginBottom: '3px',
                                    width: '120px;'
                                },
                                domProps: { value: params.row.selfName, type: 'text' },
                                on: {
                                    input: value => {
                                        params.row.selfName = value;
                                    }
                                }
                            },
                            this.$t('pgCommon.RESERVATION_NODATA')
                        );
                    }
                }
            ] //节点列表字段
        };
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    // 定义并实现方法体
    methods: {
        cancel() {
            this.$emit('menuDistributDialogClose');
        },
        // 初始化按钮信息
        // 查询数据
        btnQuery() {
            this.loading = true;
            Api.getMenuList({}, response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('template/listMenuInfos', response.data.statusMessage);
                    return;
                }
                this.menutableData = response.data.content;
                // this.total = response.data.count;
                this.loading = false;
            });
        },
        // 初始化用户角色信息

        // 保存角色，菜单配置
        save() {
            let selectItem = this.$refs.menutable.getSelectAllRows();
            let menuList = [];
            for (let i = 0; i < selectItem.length; i++) {
                let menu = {};
                menu.menuId = selectItem[i].menuId;
                console.info(selectItem[i].selfName);
                if (undefined != selectItem[i].selfName && '' != selectItem[i].selfName) {
                    menu.menuName = selectItem[i].selfName;
                } else {
                    menu.menuName = selectItem[i].menuName;
                }
                menu.functionName = selectItem[i].functionName;
                menuList.push(menu);
            }
            let param = {
                processDefKey: this.templateKey,
                taskDefKey: this.menuParam.taskKey,
                menuInfoList: menuList
            };
            console.info(param);
            Api.saveMenuList(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('template/listMenuInfos', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.menuDistributDialogClose();
                // this.total = response.data.count;
                this.loading = false;
            });
            console.info(selectItem);
        },
        // 关闭窗口之前需要调用的方法
        menuDistributDialogClose() {
            this.$emit('menuDistributDialogClose');
            this.dialogMenuDistributVisible = false;
        }
    }
};
</script>
